import styled from "styled-components";

export const DefaultTemplateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
